export default "__VITE_ASSET__DBoFvXPq__"